import { createContext } from 'react';
export const SocketContext = createContext(undefined);
SocketContext.displayName = 'SocketContext';
